(function() {

    'use strict';

    angular.module('Services').factory('ComplianceRemindersTable', ComplianceRemindersTable);
    ComplianceRemindersTable.$inject = [
        '$location',
        'ComplianceService',
        'TableLiteFactory',
        'toastr',
        '$uibModal',
        '$rootScope',
        '$filter',
        'ConfirmationModalFactory'
    ];

    function ComplianceRemindersTable(
        $location,
        ComplianceService,
        TableLiteFactory,
        toastr,
        $uibModal,
        $rootScope,
        $filter,
        ConfirmationModalFactory
    ) {
        return function (compliance) {
            const deleteConf = new ConfirmationModalFactory({},{
                message: 'messages.warning.deleteRecord.MESSAGE',
                code: 'messages.warning.statusChange.CODE'
            });

            function openRemindersTable(reminder) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    controller: 'ReminderModalController',
                    templateUrl: '/templates/pages/compliance/modals/ReminderModal.html',
                    backdrop: 'static',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        reminder: ()=>reminder,
                        compliance: ()=>compliance
                    }
                }).result.then((compliance)=>{
                    sendRequest({});
                });
            }
            const tableData = {
                /*tableName: 'ComplianceRemindersTable',*/
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add new',
                        tooltip: 'Add new compliance rule',
                        onClick: function(){
                            openRemindersTable({});
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableMinHeight: '10em'
                },
                headers: [{
                    label: 'Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Message',
                    viewName: 'message',
                    filterName: 'message',
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Frequency',
                    viewName: 'frequencyTimes'
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    width: '150px',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function(header) {
                            const filter = {};

                            filter[header.filterName] = header.filter.model === 'Enabled';

                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Date Created',
                    viewName: 'dateCreated',
                    filterName: 'createdDate'
                }, {
                    label: 'Date Updated',
                    viewName: 'dateUpdated',
                    filterName: 'modifiedDate'
                }, {
                    label: 'Actions',
                    viewName: 'action',
                    class: 'text-center'
                }],
                rowOnClick: row=>openRemindersTable(row),
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: ComplianceService.reminders.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        'complianceItem.id': compliance.id
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;


            function deleteReminder(row) {
                row.action.buttons[0].text = 'Deleting...';
                ComplianceService.reminders.delete(data => {
                    toastr.success('Reminder deleted');
                    sendRequest({});
                }, error => {
                    toastr.error('Unable to delete reminder', error.message);
                }, row.id);
            }

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if(!data) {
                    return null;
                }

                angular.forEach(data.content, function(row, index) {
                    row.status = row.active ? 'Enabled' : 'Disabled';
                    row.dateCreated = $filter('bbaDate')(row.createdDate);
                    row.dateUpdated = $filter('bbaDate')(row.modifiedDate);
                    row.frequencyTimes = `${row.frequency} ${row.frequencyNumber} ${row.frequencyUnit}`;
                    row.action = {
                        type: 'button',
                        buttons: [{
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: function () {
                                deleteConf.getInstance().result.then(cond => {
                                    if(cond) {
                                        deleteReminder(row);
                                    }
                                });
                            }
                        }]
                    };
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/compliance/ComplianceRemindersTable.js